import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

type SeoProps = {
  title: string;
  description: string;
  /** defaults to canonical URL (primary domain) */
  canonicalPath?: string;
  /** set true for auth/admin/utility pages */
  noIndex?: boolean;
  /** optional social preview image (absolute URL). Falls back to site placeholder. */
  imageUrl?: string;
};

const SITE_ORIGIN = "https://mivobox.com";
const DEFAULT_OG_IMAGE = `${SITE_ORIGIN}/og-home.png`;

export function Seo({ title, description, canonicalPath, noIndex, imageUrl }: SeoProps) {
  const location = useLocation();

  const canonicalUrl = `${SITE_ORIGIN}${canonicalPath ?? location.pathname}`;
  const ogImage = imageUrl ?? DEFAULT_OG_IMAGE;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonicalUrl} />

      {noIndex ? (
        <meta name="robots" content="noindex, nofollow" />
      ) : (
        <meta name="robots" content="index, follow" />
      )}

      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={ogImage} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@mivoboxcom" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
}
